/**
 * BrunoMusicLibrary — built-in royalty-free track catalog.
 *
 * URLs point to royalty-free CDN-hosted snippets. The list is intentionally
 * small and curated; users can preview, attach, set volume and trim a clip.
 */

export const MUSIC_LIBRARY = [
  {
    id: "vibrant-pop",
    title: "Vibrant Pop",
    artist: "Bruno Sound",
    duration: 28,
    cover: "🎵",
    color: "#FF6A00",
    url: "https://www.soundjay.com/buttons/sounds/button-09.mp3",
    category: "pop",
  },
  {
    id: "chill-vibes",
    title: "Chill Vibes",
    artist: "Bruno Sound",
    duration: 30,
    cover: "🌊",
    color: "#3B82F6",
    url: "https://cdn.pixabay.com/audio/2022/03/15/audio_1c1de9a4ba.mp3",
    category: "chill",
  },
  {
    id: "epic-cinema",
    title: "Epic Cinema",
    artist: "Bruno Sound",
    duration: 40,
    cover: "🎬",
    color: "#8B5CF6",
    url: "https://cdn.pixabay.com/audio/2022/10/16/audio_d8a09f4f31.mp3",
    category: "cinematic",
  },
  {
    id: "happy-acoustic",
    title: "Happy Acoustic",
    artist: "Bruno Sound",
    duration: 25,
    cover: "🪕",
    color: "#10B981",
    url: "https://cdn.pixabay.com/audio/2022/03/10/audio_4ec2cf5fbb.mp3",
    category: "acoustic",
  },
  {
    id: "lofi-study",
    title: "Lofi Study",
    artist: "Bruno Sound",
    duration: 35,
    cover: "📚",
    color: "#EC4899",
    url: "https://cdn.pixabay.com/audio/2022/05/27/audio_1808fbf07a.mp3",
    category: "lofi",
  },
  {
    id: "edm-energy",
    title: "EDM Energy",
    artist: "Bruno Sound",
    duration: 28,
    cover: "⚡",
    color: "#F59E0B",
    url: "https://cdn.pixabay.com/audio/2022/11/22/audio_befb09b8ce.mp3",
    category: "edm",
  },
  {
    id: "ambient-dream",
    title: "Ambient Dream",
    artist: "Bruno Sound",
    duration: 32,
    cover: "🌙",
    color: "#6366F1",
    url: "https://cdn.pixabay.com/audio/2022/10/12/audio_43fa68b4f4.mp3",
    category: "ambient",
  },
  {
    id: "trap-beat",
    title: "Trap Beat",
    artist: "Bruno Sound",
    duration: 26,
    cover: "🔥",
    color: "#EF4444",
    url: "https://cdn.pixabay.com/audio/2022/03/19/audio_da64cd1a8d.mp3",
    category: "trap",
  },
];

export const CATEGORIES = [
  { id: "all", label: "Todas" },
  { id: "pop", label: "Pop" },
  { id: "chill", label: "Chill" },
  { id: "cinematic", label: "Cinema" },
  { id: "acoustic", label: "Acústica" },
  { id: "lofi", label: "Lofi" },
  { id: "edm", label: "EDM" },
  { id: "ambient", label: "Ambient" },
  { id: "trap", label: "Trap" },
];
